import { Directive, Inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { Environment } from '@lsq-frontend/remote-services/enterprise/common';

@Directive({
    selector: '[environments]'
})
export class EnvironmentsDirective implements OnInit {
    private _hasEmbeddedView = false;
    private _environments: Environment[];

    constructor(
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef,
        @Inject(SETTINGS) private _settings: ISettings
    ) {}

    @Input()
    public set environments(environments: Environment[]) {
        this._environments = environments;

        if (
            environments &&
            environments.length &&
            environments.some((env) => env === this._settings.environment)
        ) {
            if (!this._hasEmbeddedView) {
                this._viewContainerRef.createEmbeddedView(this._templateRef);
                this._hasEmbeddedView = true;
            }
        }
    }

    public ngOnInit(): void {
        if ((!this._environments || !this._environments.length) && !this._hasEmbeddedView) {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._hasEmbeddedView = true;
        }
    }
}
